import { DOOR_STATUS_CLOSING, DOOR_STATUS_OPENED, DOOR_STATUS_OPENING } from '../../../constants.ts';

export function Door(props: Readonly<{ doorStatus: string }>) {
  let textColor = '#151d48';
  if ([DOOR_STATUS_CLOSING, DOOR_STATUS_OPENING, DOOR_STATUS_OPENED].includes(props.doorStatus)) {
    textColor = '#FFC700';
  }
  return (
    <>
      <p className="text-basic d-flex align-items-center" style={{ color: textColor }}>
        <img src="/theme/media/doors.svg" height="18" alt="Battery" className={'me-1'} />
        {props.doorStatus}
      </p>
    </>
  );
}
